var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwingTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#006AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8585 8.43247C18.2103 5.72118 24.1652 4.69986 25.6682 4.87928L25.8438 5.76295L25.5628 5.71464C24.2 5.4568 17.5931 6.2754 11.4285 9.74159C10.6434 10.1828 9.74607 10.7889 8.91934 11.4202C8.01822 12.1253 5.17998 14.6004 4.91016 16.0363C5.34433 13.2337 9.61639 10.0752 12.8585 8.43247Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6843 12.7977C26.6843 12.7977 26.4991 13.9756 26.2837 14.9712C25.4222 15.6917 23.3254 17.0355 21.3613 17.7276C21.2122 16.6727 20.5474 16.4057 19.8815 15.6397C18.8029 14.3999 19.0459 13.4791 20.4768 13.2762C24.7488 12.6727 25.7739 11.3289 26.6828 9.93519C28.3204 7.42812 27.8733 5.17383 27.8733 5.17383C30.2027 9.21471 26.002 13.44 24.6659 14.5542C24.7873 14.4691 25.5816 13.9472 26.6834 12.7986L26.6843 12.7977Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4293 8.31547C21.5058 8.18908 20.372 8.88981 20.3557 9.97744C20.0085 10.1735 20.5838 9.8287 20.3555 9.97744C20.3557 10.3952 20.9923 10.8329 21.1695 11.2092C21.8889 11.2324 21.6677 11.0092 22.1174 10.6713H22.1183C22.1183 10.6713 21.7322 10.8311 21.0654 11.04C21.2687 11.5757 21.4679 12.3849 21.7375 12.586C22.7679 13.3513 23.7284 11.9472 23.8258 10.8329C23.9627 9.30423 23.5148 8.46421 22.4293 8.31461V8.31547Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2286 18.0405H21.292C21.4893 17.964 21.6866 17.884 21.8847 17.7997C26.3131 15.9244 30.0859 12.1928 30.9293 9.36133C31.2826 12.0027 29.1071 15.6656 26.2278 18.0405H26.2286Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0811 5.29297C28.0811 5.29297 30.1747 5.7187 30.7537 7.27492C31.952 10.4966 26.9243 14.136 26.9243 14.136C26.9243 14.136 31.1939 10.2111 30.0826 7.63861C29.6346 6.60084 28.4688 6.28173 28.4688 6.28173L28.0811 5.29297Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58048 23.9057C8.37459 24.1975 8.08637 24.6976 8.21021 25.4063C6.50215 24.9072 4.99235 23.1701 4.74498 22.6824C3.05599 19.352 5.30671 15.6834 9.98795 13.0791C6.03666 15.5611 4.22785 18.5677 5.36737 21.1015C5.91477 22.3195 6.95946 23.5683 8.58048 23.9057Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72592 25.9992C9.33745 25.9992 9.83319 25.5045 9.83319 24.8941C9.83319 24.2838 9.33745 23.7891 8.72592 23.7891C8.11439 23.7891 7.61865 24.2838 7.61865 24.8941C7.61865 25.5045 8.11439 25.9992 8.72592 25.9992Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89942 25.3516C8.89942 25.448 8.8211 25.5264 8.72559 25.5264C8.63008 25.5264 8.55176 25.448 8.55176 25.3516C8.55176 25.2551 8.63008 25.1777 8.72559 25.1777C8.8211 25.1777 8.89942 25.2561 8.89942 25.3516Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72604 25.2503C8.81009 25.2503 8.88077 25.3105 8.89796 25.3898C8.90082 25.3783 8.90178 25.3659 8.90178 25.3535C8.90178 25.257 8.82346 25.1777 8.72604 25.1777C8.62861 25.1777 8.55029 25.2561 8.55029 25.3535C8.55029 25.3659 8.55125 25.3783 8.55411 25.3898C8.57035 25.3105 8.64103 25.2503 8.72604 25.2503Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30673 25.2751C8.28571 25.3477 8.2093 25.3888 8.13671 25.3678C8.06412 25.3467 8.02305 25.2703 8.04407 25.1977C8.06508 25.1252 8.14149 25.0841 8.21408 25.1051C8.28667 25.1261 8.32774 25.2025 8.30673 25.2751Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20003 25.1586C8.26307 25.1767 8.30223 25.2379 8.29745 25.3009C8.30223 25.2923 8.3051 25.2837 8.30796 25.2751C8.32897 25.2025 8.2879 25.1261 8.21532 25.1051C8.14273 25.0841 8.06727 25.1252 8.0453 25.1977C8.04244 25.2073 8.04053 25.2159 8.04053 25.2254C8.07014 25.1691 8.13604 25.1404 8.19908 25.1586L8.20003 25.1586Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86378 25.0817C7.84659 25.1391 7.79215 25.1734 7.74153 25.1582C7.6909 25.1429 7.66321 25.0846 7.6804 25.0273C7.69759 24.97 7.75203 24.9356 7.80265 24.9509C7.85327 24.9662 7.88097 25.0244 7.86378 25.0817Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78991 24.9939C7.83384 25.0072 7.86059 25.0531 7.85486 25.1028C7.85772 25.0961 7.86059 25.0894 7.86345 25.0817C7.88064 25.0244 7.85295 24.9662 7.80232 24.9509C7.7517 24.9356 7.69726 24.97 7.68007 25.0273C7.67816 25.0349 7.67625 25.0416 7.67529 25.0493C7.69822 25.0044 7.74502 24.9805 7.78895 24.9929L7.78991 24.9939Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15102 25.2751C9.17203 25.3477 9.24844 25.3888 9.32103 25.3678C9.39362 25.3467 9.43469 25.2703 9.41368 25.1977C9.39267 25.1252 9.31626 25.0841 9.24462 25.1051C9.17203 25.1261 9.13096 25.2025 9.15198 25.2751L9.15102 25.2751Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25795 25.1586C9.19491 25.1767 9.15575 25.2379 9.16053 25.3009C9.15575 25.2923 9.15289 25.2837 9.15002 25.2751C9.12901 25.2025 9.17008 25.1261 9.24267 25.1051C9.31526 25.0841 9.39071 25.1252 9.41268 25.1977C9.41555 25.2073 9.41746 25.2159 9.41746 25.2254C9.38785 25.1691 9.32195 25.1404 9.25891 25.1586L9.25795 25.1586Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58469 25.0817C9.60189 25.1391 9.65633 25.1734 9.70695 25.1582C9.75757 25.1429 9.78527 25.0846 9.76808 25.0273C9.75089 24.97 9.69644 24.9356 9.64582 24.9509C9.5952 24.9662 9.5675 25.0244 9.58469 25.0817Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65824 24.9939C9.6143 25.0072 9.58756 25.0531 9.59329 25.1028C9.59042 25.0961 9.58756 25.0894 9.58469 25.0817C9.5675 25.0244 9.5952 24.9662 9.64582 24.9509C9.69644 24.9356 9.75089 24.97 9.76808 25.0273C9.76999 25.0349 9.7719 25.0416 9.77285 25.0493C9.74993 25.0044 9.70313 24.9805 9.65919 24.9929L9.65824 24.9939Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8615 24.7059C8.8615 24.7814 8.80037 24.8434 8.72396 24.8434C8.64755 24.8434 8.58643 24.7823 8.58643 24.7059C8.58643 24.6295 8.64755 24.5684 8.72396 24.5684C8.80037 24.5684 8.8615 24.6295 8.8615 24.7059Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72392 24.6257C8.79078 24.6257 8.84618 24.6725 8.85859 24.7355C8.8605 24.726 8.86146 24.7164 8.86146 24.7069C8.86146 24.6304 8.79938 24.5684 8.72297 24.5684C8.64656 24.5684 8.58447 24.6304 8.58447 24.7069C8.58447 24.7164 8.58543 24.726 8.58734 24.7355C8.60071 24.6725 8.65611 24.6257 8.72201 24.6257L8.72392 24.6257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39304 24.65C8.37584 24.7073 8.31663 24.7398 8.25932 24.7226C8.20201 24.7054 8.16954 24.6462 8.18673 24.5889C8.20392 24.5316 8.26314 24.4991 8.32045 24.5163C8.37775 24.5335 8.41023 24.5927 8.39304 24.65Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30725 24.5592C8.35692 24.5736 8.38844 24.6213 8.38366 24.671C8.38748 24.6643 8.39035 24.6576 8.39226 24.65C8.40945 24.5927 8.37697 24.5325 8.31967 24.5162C8.26236 24.4991 8.20314 24.5325 8.18595 24.5888C8.18404 24.5965 8.18213 24.6032 8.18213 24.6108C8.20601 24.5669 8.25758 24.5439 8.30725 24.5583L8.30725 24.5592Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04893 24.4931C8.03549 24.5382 7.99228 24.5651 7.95195 24.5536C7.91163 24.5421 7.8905 24.495 7.90394 24.4499C7.91739 24.4047 7.9606 24.3779 8.00092 24.3894C8.04125 24.4009 8.06237 24.448 8.04893 24.4931Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99211 24.423C8.02668 24.4336 8.0478 24.47 8.04396 24.5094C8.04684 24.5046 8.04876 24.4988 8.05068 24.4931C8.06413 24.448 8.04204 24.4009 8.00267 24.3894C7.96235 24.3779 7.91914 24.4047 7.9057 24.4499C7.90378 24.4556 7.90282 24.4614 7.90186 24.4672C7.9201 24.4316 7.95755 24.4124 7.99211 24.423Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06124 24.6481C9.07843 24.7054 9.13765 24.7379 9.19496 24.7207C9.25227 24.7035 9.28474 24.6443 9.26755 24.587C9.25036 24.5296 9.19114 24.4972 9.13383 24.5144C9.07652 24.5316 9.04405 24.5908 9.06124 24.6481Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14625 24.5573C9.09658 24.5716 9.06506 24.6194 9.06984 24.669C9.06602 24.6623 9.06315 24.6556 9.06124 24.648C9.04405 24.5907 9.07652 24.5305 9.13383 24.5143C9.19114 24.4971 9.25036 24.5305 9.26755 24.5869C9.26946 24.5945 9.27137 24.6012 9.27137 24.6088C9.24749 24.5649 9.19591 24.542 9.14625 24.5563L9.14625 24.5573Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40834 24.4931C9.42179 24.5382 9.46499 24.5651 9.50532 24.5536C9.54565 24.5421 9.56677 24.495 9.55333 24.4499C9.53989 24.4047 9.49668 24.3779 9.45635 24.3894C9.41603 24.4009 9.3949 24.448 9.40738 24.4931L9.40834 24.4931Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46828 24.423C9.43371 24.4336 9.41259 24.47 9.41643 24.5094C9.41355 24.5046 9.41163 24.4988 9.40971 24.4931C9.39627 24.448 9.41835 24.4009 9.45772 24.3894C9.49805 24.3779 9.54126 24.4047 9.5547 24.4499C9.55662 24.4556 9.55758 24.4614 9.55854 24.4672C9.5403 24.4316 9.50285 24.4124 9.46828 24.423Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82091 24.2127C8.82091 24.2652 8.77793 24.3082 8.7254 24.3082C8.67286 24.3082 8.62988 24.2652 8.62988 24.2127C8.62988 24.1602 8.67286 24.1172 8.7254 24.1172C8.77793 24.1172 8.82091 24.1602 8.82091 24.2127Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72635 24.1573C8.77315 24.1573 8.81136 24.1898 8.82091 24.2337C8.82186 24.227 8.82282 24.2203 8.82282 24.2137C8.82282 24.1602 8.77984 24.1172 8.72635 24.1172C8.67286 24.1172 8.62988 24.1602 8.62988 24.2137C8.62988 24.2203 8.62988 24.227 8.63179 24.2337C8.64134 24.1898 8.67955 24.1573 8.72635 24.1573Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49374 24.1714C8.48221 24.2117 8.43997 24.2338 8.39964 24.2223C8.35931 24.2107 8.33723 24.1685 8.34875 24.1282C8.36027 24.0878 8.40252 24.0657 8.44285 24.0773C8.48317 24.0888 8.50526 24.131 8.49374 24.1714Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43404 24.107C8.46861 24.1175 8.49069 24.1502 8.48781 24.1857C8.49069 24.1809 8.49261 24.1761 8.49357 24.1713C8.50509 24.131 8.48301 24.0887 8.44268 24.0772C8.40235 24.0657 8.36107 24.0887 8.34858 24.1281C8.34666 24.1329 8.3457 24.1386 8.3457 24.1434C8.36203 24.1127 8.39851 24.0964 8.43404 24.107Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25115 24.0682C8.24154 24.0999 8.21178 24.1191 8.18393 24.1105C8.15609 24.1018 8.14072 24.0701 8.15033 24.0385C8.15993 24.0068 8.18969 23.9876 8.21754 23.9962C8.24539 24.0049 8.26075 24.0365 8.25115 24.0682Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21087 24.0193C8.23487 24.0269 8.25023 24.0519 8.24735 24.0797C8.24927 24.0759 8.25119 24.0721 8.25215 24.0682C8.26176 24.0365 8.24639 24.0039 8.21855 23.9962C8.1907 23.9876 8.15998 24.0068 8.15133 24.0385C8.15037 24.0423 8.14941 24.0461 8.14941 24.0509C8.1619 24.026 8.18782 24.0125 8.21279 24.0202L8.21087 24.0193Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95666 24.1714C8.96818 24.2117 9.01043 24.2338 9.05076 24.2223C9.09108 24.2107 9.11317 24.1685 9.10165 24.1282C9.09012 24.0878 9.04788 24.0657 9.00755 24.0773C8.96722 24.0888 8.94514 24.131 8.95666 24.1714Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01619 24.107C8.98162 24.1175 8.95954 24.1502 8.96242 24.1857C8.95954 24.1809 8.95762 24.1761 8.95666 24.1713C8.94514 24.131 8.96722 24.0887 9.00755 24.0772C9.04788 24.0657 9.08916 24.0887 9.10165 24.1281C9.10357 24.1329 9.10453 24.1386 9.10453 24.1434C9.0882 24.1127 9.05172 24.0964 9.01619 24.107Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2016 24.0702C9.2112 24.1019 9.24096 24.1211 9.26881 24.1124C9.29665 24.1038 9.31202 24.0721 9.30242 24.0404C9.29281 24.0087 9.26305 23.9895 9.2352 23.9982C9.20736 24.0068 9.19199 24.0385 9.2016 24.0702Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24288 24.0212C9.21888 24.0289 9.20352 24.0539 9.2064 24.0817C9.20448 24.0779 9.20256 24.074 9.2016 24.0702C9.19199 24.0385 9.20736 24.0058 9.2352 23.9982C9.26305 23.9895 9.29377 24.0087 9.30242 24.0404C9.30338 24.0443 9.30434 24.0481 9.30434 24.0529C9.29185 24.0279 9.26593 24.0145 9.24096 24.0222L9.24288 24.0212Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59418 24.9619C8.59418 25.0345 8.53496 25.0937 8.46237 25.0937C8.38978 25.0937 8.33057 25.0345 8.33057 24.9619C8.33057 24.8893 8.38978 24.8301 8.46237 24.8301C8.53496 24.8301 8.59418 24.8893 8.59418 24.9619Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46333 24.8855C8.52732 24.8855 8.58081 24.9304 8.59323 24.9905C8.59514 24.9819 8.59609 24.9724 8.59609 24.9628C8.59609 24.8893 8.53687 24.8301 8.46333 24.8301C8.38978 24.8301 8.33057 24.8893 8.33057 24.9628C8.33057 24.9724 8.33152 24.981 8.33343 24.9905C8.34585 24.9304 8.39934 24.8855 8.46333 24.8855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12543 24.9638C9.12543 25.0364 9.06621 25.0956 8.99362 25.0956C8.92103 25.0956 8.86182 25.0364 8.86182 24.9638C8.86182 24.8912 8.92103 24.832 8.99362 24.832C9.06621 24.832 9.12543 24.8912 9.12543 24.9638Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99458 24.8874C9.05857 24.8874 9.11206 24.9323 9.12448 24.9925C9.12639 24.9839 9.12734 24.9743 9.12734 24.9648C9.12734 24.8912 9.06812 24.832 8.99458 24.832C8.92103 24.832 8.86182 24.8912 8.86182 24.9648C8.86182 24.9743 8.86277 24.9829 8.86468 24.9925C8.8771 24.9323 8.93059 24.8874 8.99458 24.8874Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14449 24.8966C8.12825 24.951 8.0719 24.9816 8.01746 24.9663C7.96302 24.9501 7.93245 24.8937 7.94869 24.8393C7.96493 24.7848 8.02128 24.7543 8.07572 24.7696C8.13016 24.7858 8.16073 24.8421 8.14449 24.8966Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06177 24.81C8.10953 24.8243 8.13914 24.8692 8.13436 24.917C8.13723 24.9113 8.14009 24.9046 8.142 24.8969C8.15824 24.8425 8.12672 24.7852 8.07323 24.7699C8.01879 24.7537 7.96244 24.7852 7.9462 24.8396C7.94429 24.8463 7.94334 24.8539 7.94238 24.8606C7.96531 24.8186 8.01402 24.7966 8.06177 24.811L8.06177 24.81Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81454 24.7617C7.80109 24.8059 7.75885 24.8327 7.72044 24.8212C7.68203 24.8097 7.65995 24.7646 7.67339 24.7204C7.68683 24.6762 7.72908 24.6493 7.76749 24.6609C7.80685 24.6724 7.82798 24.7175 7.81454 24.7617Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75681 24.6935C7.79138 24.7031 7.81154 24.7396 7.8077 24.778C7.81058 24.7732 7.8125 24.7675 7.81442 24.7617C7.82786 24.7175 7.80674 24.6724 7.76737 24.6609C7.728 24.6493 7.68576 24.6762 7.67231 24.7204C7.67039 24.7262 7.66943 24.7319 7.66943 24.7377C7.68672 24.7031 7.7232 24.6839 7.75777 24.6945L7.75681 24.6935Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31496 24.8946C9.3312 24.9491 9.38755 24.9796 9.442 24.9644C9.49644 24.9481 9.527 24.8918 9.51172 24.8373C9.49644 24.7829 9.43913 24.7523 9.38469 24.7676C9.33025 24.7838 9.29968 24.8402 9.31496 24.8946Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3975 24.8081C9.34974 24.8224 9.32013 24.8673 9.32491 24.915C9.32204 24.9093 9.31918 24.9026 9.31727 24.895C9.30103 24.8405 9.33255 24.7832 9.38603 24.7679C9.44048 24.7517 9.49683 24.7832 9.51306 24.8377C9.51498 24.8444 9.51593 24.852 9.51689 24.8587C9.49396 24.8167 9.44525 24.7947 9.3975 24.809L9.3975 24.8081Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64605 24.7617C9.65949 24.8059 9.70174 24.8327 9.74014 24.8212C9.77951 24.8097 9.80063 24.7646 9.78719 24.7204C9.77375 24.6762 9.7315 24.6493 9.69309 24.6609C9.65469 24.6724 9.6326 24.7175 9.64605 24.7617Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7018 24.6935C9.66723 24.7031 9.64707 24.7396 9.65091 24.778C9.64803 24.7732 9.64611 24.7675 9.64419 24.7617C9.63074 24.7175 9.65187 24.6724 9.69124 24.6609C9.7306 24.6493 9.77285 24.6762 9.78629 24.7204C9.78821 24.7262 9.78917 24.7319 9.78917 24.7377C9.77189 24.7031 9.7354 24.6839 9.70084 24.6945L9.7018 24.6935Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52753 24.515C8.58292 24.515 8.62782 24.4701 8.62782 24.4147C8.62782 24.3594 8.58292 24.3145 8.52753 24.3145C8.47215 24.3145 8.42725 24.3594 8.42725 24.4147C8.42725 24.4701 8.47215 24.515 8.52753 24.515Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52849 24.3565C8.5772 24.3565 8.61827 24.3909 8.62782 24.4367C8.62878 24.43 8.62973 24.4233 8.62973 24.4157C8.62973 24.3593 8.58484 24.3145 8.52849 24.3145C8.47214 24.3145 8.42725 24.3593 8.42725 24.4157C8.42725 24.4224 8.42725 24.43 8.42916 24.4367C8.43871 24.3909 8.47978 24.3565 8.52849 24.3565Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92939 24.515C8.98478 24.515 9.02968 24.4701 9.02968 24.4147C9.02968 24.3594 8.98478 24.3145 8.92939 24.3145C8.874 24.3145 8.8291 24.3594 8.8291 24.4147C8.8291 24.4701 8.874 24.515 8.92939 24.515Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92839 24.3565C8.9771 24.3565 9.01817 24.3909 9.02772 24.4367C9.02868 24.43 9.02963 24.4233 9.02963 24.4157C9.02963 24.3593 8.98474 24.3145 8.92839 24.3145C8.87204 24.3145 8.82715 24.3593 8.82715 24.4157C8.82715 24.4224 8.82715 24.43 8.82906 24.4367C8.83861 24.3909 8.87968 24.3565 8.92839 24.3565Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2815 24.3669C8.26901 24.4082 8.22581 24.4322 8.18356 24.4197C8.14227 24.4072 8.11826 24.364 8.13075 24.3217C8.14323 24.2805 8.18644 24.2564 8.22773 24.2689C8.26901 24.2814 8.29302 24.3246 8.28054 24.3669L8.2815 24.3669Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21767 24.3006C8.25415 24.3112 8.27624 24.3457 8.27336 24.3822C8.27624 24.3774 8.27816 24.3726 8.27912 24.3669C8.2916 24.3256 8.2676 24.2814 8.22631 24.2689C8.18502 24.2564 8.14085 24.2804 8.12837 24.3227C8.12645 24.3285 8.12549 24.3333 8.12549 24.339C8.14277 24.3064 8.18022 24.29 8.21671 24.3006L8.21767 24.3006Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02873 24.2624C8.01913 24.296 7.98649 24.3162 7.95672 24.3075C7.92695 24.2989 7.91063 24.2643 7.92023 24.2307C7.92983 24.1971 7.96248 24.177 7.99225 24.1856C8.02201 24.1942 8.03834 24.2288 8.02873 24.2624Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98565 24.2106C8.01158 24.2182 8.02694 24.2451 8.02406 24.2749C8.02598 24.271 8.0279 24.2672 8.02886 24.2624C8.03846 24.2288 8.0231 24.1942 7.99237 24.1856C7.96261 24.177 7.92996 24.1971 7.92036 24.2307C7.9194 24.2346 7.91844 24.2394 7.91748 24.2432C7.93092 24.2173 7.95877 24.2029 7.98469 24.2106L7.98565 24.2106Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17176 24.3669C9.18425 24.4082 9.22745 24.4322 9.26874 24.4197C9.31003 24.4072 9.33403 24.364 9.32155 24.3217C9.30907 24.2805 9.26586 24.2564 9.22457 24.2689C9.18329 24.2814 9.15928 24.3246 9.17176 24.3669Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23321 24.3006C9.19673 24.3112 9.17464 24.3457 9.17752 24.3822C9.17464 24.3774 9.17272 24.3726 9.17176 24.3669C9.15928 24.3256 9.18328 24.2814 9.22457 24.2689C9.26586 24.2564 9.31003 24.2804 9.32251 24.3227C9.32443 24.3285 9.32539 24.3333 9.32539 24.339C9.30811 24.3064 9.27066 24.29 9.23418 24.3006L9.23321 24.3006Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42414 24.2624C9.43374 24.296 9.46639 24.3162 9.49615 24.3075C9.52592 24.2989 9.54224 24.2643 9.53264 24.2307C9.52304 24.1971 9.49039 24.177 9.46063 24.1856C9.43086 24.1942 9.41454 24.2288 9.42414 24.2624Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46939 24.2106C9.44347 24.2182 9.4281 24.2451 9.43098 24.2749C9.42906 24.271 9.42714 24.2672 9.42618 24.2624C9.41658 24.2288 9.43194 24.1942 9.46267 24.1856C9.49243 24.177 9.52508 24.1971 9.53468 24.2307C9.53564 24.2346 9.5366 24.2394 9.53756 24.2432C9.52412 24.2173 9.49628 24.2029 9.47035 24.2106L9.46939 24.2106Z",
    fill: "white"
  })))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1001 4.10539C27.6495 4.2591 27.7853 5.07446 27.8163 5.50659L27.8185 5.50829C27.873 6.26636 27.6876 7.34694 27.6876 7.34694C27.6788 6.97076 27.4873 6.39792 27.0579 6.20314C26.702 6.04207 26.2745 6.10052 25.9787 5.74397C25.9431 5.70104 25.9124 5.6559 25.8857 5.60955C25.6194 5.01499 25.4895 3.88177 27.1001 4.10539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwingTypeIcon);
export default __webpack_public_path__ + "static/media/swingTypeIcon.587bbd5036915c3a6abea131279b6636.svg";
export { ForwardRef as ReactComponent };